<mat-card appearance="outlined" class="contact-card">
  <mat-card-content>

    <div class="contact-header">
      <mat-icon class="contact-avatar">person</mat-icon>
      <div class="contact-header-copy">
        <span class="contact-name">{{ Contact.LastName }}, {{ Contact.FirstName }}</span>
        @if (Contact.Relation) {
          <span class="contact-relation">{{ Contact.Relation }}</span>
        }
      </div>
      @if (isAllowedToEdit) {
        <button mat-icon-button class="contact-delete-btn" (click)="deleteContact()" aria-label="Delete contact">
          <mat-icon>delete_outline</mat-icon>
        </button>
      }
    </div>

    <div class="contact-details">
      @if (Contact.HomePhone) {
        <a [href]="'tel:' + Contact.HomePhone" class="contact-row">
          <mat-icon class="contact-row-icon">phone</mat-icon>
          <span>{{ Contact.HomePhone }}</span>
        </a>
      }
      @if (Contact.MobilePhone) {
        <a [href]="'tel:' + Contact.MobilePhone" class="contact-row">
          <mat-icon class="contact-row-icon">smartphone</mat-icon>
          <span>{{ Contact.MobilePhone }}</span>
        </a>
      }
      @if (Contact.Email) {
        <a [href]="'mailto:' + Contact.Email" class="contact-row">
          <mat-icon class="contact-row-icon">mail_outline</mat-icon>
          <span>{{ Contact.Email }}</span>
        </a>
      }
      @for (address of Contact.Addresses; track address.AddressId) {
        <div class="contact-row contact-address">
          <mat-icon class="contact-row-icon" style="align-self: flex-start;">home</mat-icon>
          <div class="contact-address-lines">
            @if (address.Address1) { <span>{{ address.Address1 }}</span> }
            @if (address.Address2) { <span>{{ address.Address2 }}</span> }
            @if (address.Address3) { <span>{{ address.Address3 }}</span> }
            @if (address.City) { <span>{{ address.PostCode }}&nbsp;{{ address.City }}</span> }
            @if (address.Country) { <span>{{ address.Country }}</span> }
          </div>
        </div>
      }
    </div>

  </mat-card-content>
</mat-card>
